import { useState } from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import { GraphViewer } from '../components/graph/GraphViewer';
import { UserProfile, PasswordChange, PreferencesPanel, UserList, UserForm } from '@lingaai/user-management';
import { useCurrentUser } from '@lingaai/user-management';
import type { User } from '@lingaai/user-management';

export function Settings() {
  const [tab, setTab] = useState(0);
  const { data: user } = useCurrentUser();
  const isAdmin = user?.role && ['super_admin', 'admin', 'billing_admin'].includes(user.role);
  const isSuperAdmin = user?.role && ['super_admin'].includes(user.role);

  const [userFormOpen, setUserFormOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | undefined>();

  const handleAddUser = () => {
    setSelectedUser(undefined);
    setUserFormOpen(true);
  };

  const handleEditUser = (user: User) => {
    setSelectedUser(user);
    setUserFormOpen(true);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="General" />
          <Tab label="User Profile" />
          {isAdmin && <Tab label="User Management" />}
          {isSuperAdmin && <Tab label="Graph Viewer" />}
        </Tabs>
      </Box>

      {tab === 0 && <Typography color="text.secondary">General settings coming soon.</Typography>}

      {tab === 1 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <UserProfile />
          <PasswordChange />
          <PreferencesPanel />
        </Box>
      )}

      {isAdmin && tab === 2 && (
        <Box>
          <UserList onAddUser={handleAddUser} onEditUser={handleEditUser} />
          <UserForm
            open={userFormOpen}
            onClose={() => {
              setUserFormOpen(false);
              setSelectedUser(undefined);
            }}
            user={selectedUser}
          />
        </Box>
      )}

      {tab === (isAdmin ? 3 : 2) && (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Visual representation of your tenant's node and edge relationships.
          </Typography>
          <GraphViewer />
        </Box>
      )}
    </Container>
  );
}
